import { useContext } from "react";
import get from "lodash.get";
import { CommonContext } from "../../context";

const RoleManager = () => {
  const {
    state: {
      roleState: { roleData },
    },
  } = useContext(CommonContext);
  const hasAccess = (name: string) => {
    try {
      return name === "notFound" ? true : get(roleData, "data")[name];
    } catch (err) {
      return false;
    }
  };

  return [hasAccess];
};

export default RoleManager;
